import { useState } from "react";
import { MenuItem } from "@mui/material";

import { claimApi } from "@/main/api";
import { getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";
import { userIsSupplier } from "@/main/services/utilsUser";

import PrintSupplierPartsReportDialog from "./printSupplierPartsReportDialog";
import { showReportTabLoading } from "./reportTabLoading";

interface IPrintSupplierPartsReportMenuItemProps {
	id: string;
	controlId: string;
	guidClaim?: string | null;
	onClose: () => void;
}

function PrintSupplierPartsReportMenuItem({
	id,
	controlId,
	guidClaim,
	onClose,
}: Readonly<IPrintSupplierPartsReportMenuItemProps>) {
	const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

	if (!guidClaim || !isShowControlByElementId(controlId)) return null;

	function print(guidSupplier?: string) {
		const reportTab = window.open("", "_blank");
		if (reportTab) showReportTabLoading(reportTab, getTranslateByKey("reportTemplateType.supplierPartsReport"));
		onClose();
		claimApi
			.printSupplierPartsReport({ guidClaim: guidClaim as string, guidSupplier })
			.then((response) => {
				const url = response.data.result?.url;
				if (url && reportTab) reportTab.location.href = url;
				else if (url) window.open(url, "_blank");
				else reportTab?.close();
			})
			.catch(() => reportTab?.close());
	}

	function handleClick() {
		if (userIsSupplier()) {
			print();
			return;
		}
		setIsDialogOpen(true);
	}

	function handleConfirm(guidSupplier: string) {
		setIsDialogOpen(false);
		print(guidSupplier);
	}

	function handleCancel() {
		setIsDialogOpen(false);
		onClose();
	}

	return (
		<>
			<MenuItem id={id} onClick={handleClick}>
				{getTranslateByKey("control.btnPrintSupplierPartsReport")}
			</MenuItem>
			<PrintSupplierPartsReportDialog
				isOpen={isDialogOpen}
				guidClaim={guidClaim}
				onCancel={handleCancel}
				onConfirm={handleConfirm}
			/>
		</>
	);
}

export default PrintSupplierPartsReportMenuItem;